import { render } from "./SignUpModule.vue?vue&type=template&id=fad20956&scoped=true"
import script from "./SignUpModule.vue?vue&type=script&lang=js"
export * from "./SignUpModule.vue?vue&type=script&lang=js"

import "./SignUpModule.vue?vue&type=style&index=0&id=fad20956&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad20956"]])

export default __exports__